<template>
    <div>
        <!-- 常见问题 -->
        <div class="weui-cells__title">
            常见问题
        </div>
        <!--  v-if="'wxId' === '12'" -->
        <div class="weui-cells" v-if="bingantong">
            <div class="hideitem" v-for="(item,index) in questionsCommon" :key='index' @click="Contain(item.id)"> 
                <span class="question_contains">{{item.contain}}</span>
                <span class="go"></span>

            </div>
        </div>
        <div class="weui-cells" v-else-if="yaopinda">
            <div class="hideitem" v-for="(item,index) in medicine_questions" :key='index' @click="Contain(item.id)"> 
                <span class="question_contains">{{item.contain}}</span>
                <span class="go"></span>

            </div>
        </div>
        <!-- 其他 -->
        <!-- <div class="weui-cells__title">
            其他
        </div>
        <div class="weui-cells">
            <div class="hideitem" v-for="(item,index) in questionsOther" :key='index' @click="Contain(item.id)">
                <span class="question_contains">{{item.contain}}</span>
                <span class="go"></span>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    name:'guide',
    data(){
        return{
            questionsCommon:[
                {contain:'全套里面是所有的病历吗?',id:'one'},
                {contain:'什么时间付款？如何付款？',id:'two'},
                {contain:'没有身份证如何申请？',id:'three'},
                {contain:'新生儿如何申请？',id:'four'},
                {contain:'患者死亡如何申请？',id:'five'},
                {contain:'病历复印规定',id:'six'},
                {contain:'如何微信申请病历？',id:'seven'},
                {contain:'如何联系病案通客服获取帮助？',id:'eight'},
                {contain:'用户隐私政策概要',id:'eleven'}    
            ],
            medicine_questions:[
                {contain:'客服热线',id:'nine'},
                {contain:'中草药怎么邮寄',id:'ten'},
            ],
            wxId:'',
            bingantong:'',
            yaopinda:''
            // medical_record:true,
            // medicine:false
            // questionsOther:[
            //     {contain:'《转外就医申请表》盖章材料？',id:'nine'},
            //     {contain:'《医保资质证明》如何办理？',id:'ten'},
            //     {contain:'如何补打《出院费用结算清单》',id:'eleven'}
            // ],
            // contain:''
        }
    },
    created:function(){
        let wxId = localStorage.getItem("wxId");
        // let wxId = 13;

        if(wxId == 13){
            console.log(this.medicine)
            this.bingantong = false
             this.yaopinda = true
            console.log('13')
        }else{
             console.log('12')
             this.bingantong = true
             this.yaopinda = false
        }
        //  console.log(wxId)
    },
    methods:{
        Contain(id){
            if(id === 'seven'){
                // window.location.href = 'https://mp.weixin.qq.com/s/DgMJH__xsKtqg18v7iU7yQ'; 
                 window.location.href = 'https://mp.weixin.qq.com/s/DgMJH__xsKtqg18v7iU7yQ'; 
            }
            else if(id === 'eight'){
                window.location.href = 'https://mp.weixin.qq.com/s/RoWTatpnko8ouVgV3Z3jDw'; 
            }
            else if(id === 'nine'){
                this.$router.push({
					path: '/hotline'
                })
            }else{
                this.$router.push({
					path: '/guidedetail/'+id,
					params: {
                        // contain:contain,
                        id: id,
                    }
                })
            }
            console.log(id)
            
        }
    }
}
</script>
<style>
.weui-cells__title {
    margin-top: .77em;
    margin-bottom: .3em;
    padding-left: 15px;
    padding-right: 15px;
    color: #999;
    font-size: 14px
}
.weui-cells {
    margin-top: 0;
    background: white;
    padding: 0px 15px;
}
.question_contains{
    line-height: 50px;
}
.go:after{
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #c8c8cd;
    border-style: solid;
    -webkit-transform: matrix(.71, .71, -.71, .71, 0, 0);
    transform: matrix(.71, .71, -.71, .71, 0, 0);
    position: relative;
    top: -2px;
    /* position: absolute; */
    top: 10px;
    margin-top: -4px;
    right: 15px
}
</style>


